import ClientAvatar from 'components/ClientAvatar/ClientAvatar';
import { Link } from 'react-router-dom';
import { useGetAccountPackageView } from 'utils/hooks/GetAccountInfo/accountPackageView';
import { Invoice } from '../../../../interface';
import InvoiceActionMenu from '../InvoiceActionMenu/InvoiceActionMenu';
import styles from './ClientInvoiceItem.module.scss';
import { useRoutesGenerator } from 'utils/hooks/Path/RoutesGenerator';

const GAE_REGION = process.env.REACT_APP_GAE_REGION;
export const MONEY_SYMBOL = GAE_REGION === 'au' ? '$' : GAE_REGION === 'gb' ? '£' : undefined;

export const STATUS_LABELS = {
  draft: 'Draft',
  issued: 'Issued',
  overdue: 'Overdue',
  markedPaid: 'Marked Paid',
  confirmPaid: 'Confirm Paid',
  closed: 'Closed'
};

interface InvoiceItemProps {
  invoice: Invoice;
  onChangeStatus: (_id: string, status: 'closed' | 'confirmPaid') => void;
  onResendInvoice: (_id: string) => void;
  isInvoiceActionProcessing: boolean;
}

const ClientInvoiceItem = ({
  invoice,
  onChangeStatus,
  onResendInvoice,
  isInvoiceActionProcessing
}: InvoiceItemProps) => {
  const { INVOICES } = useRoutesGenerator();
  const { isEdgeAdminView, isEdgeUserView, isEdgeReceptionist } = useGetAccountPackageView();

  const { _id, description, issueDate, invoiceAmount, invoiceId, status } = invoice;

  const draftPath =
    (isEdgeAdminView ? `/admin` : isEdgeReceptionist ? '/receptionist' : isEdgeUserView ? '/user' : '') +
    `/invoices/${_id}/edit`;

  return (
    <div className={styles.container}>
      <div className={styles.clientRecordWrapper}>
        <ClientAvatar
          clientData={invoice.clientRecord.clientProfiles}
          avatarSize={60}
          displayFirstNameOnly={invoice.clientRecord.recordType === 'couple'}
          displayLimit={invoice.clientRecord.recordType === 'couple' ? 2 : 1}
        />
      </div>

      {status === 'draft' ? (
        <Link className={styles.invoiceId} to={{ pathname: draftPath }}>
          {invoiceId}
        </Link>
      ) : (
        <div className={styles.invoiceId}>
          <Link className={styles.invoiceId} to={`${INVOICES.BASE}/${invoice._id}`}>
            {invoiceId}
          </Link>
        </div>
      )}
      <span className={styles.issueDate}>{issueDate}</span>
      <span className={styles.description}>
        {description ? (description.length > 70 ? `${description.slice(0, 70)}...` : description) : '-'}
      </span>
      <span className={styles.invoiceAmount}>
        {MONEY_SYMBOL}
        {invoiceAmount.toFixed(2)}
      </span>
      <div className={styles.statusWrapper}>
        <span className={`${styles.status} ${styles[status]}`}>{STATUS_LABELS[status]}</span>
      </div>
      <div className={styles.actionButtonContainer}>
        <InvoiceActionMenu
          isInvoiceActionProcessing={isInvoiceActionProcessing}
          status={status}
          invoiceId={_id}
          onChangeStatus={onChangeStatus}
          onResendInvoice={onResendInvoice}
        />
      </div>
    </div>
  );
};

export default ClientInvoiceItem;
